import React from 'react';

import { HELP_EMAIL } from 'dpl/shared/constants/breeder_app';

function getDebugSessionId(): string | undefined {
  // Global set in initReactApp; name is fixed for server/client correlation
  // eslint-disable-next-line @typescript-eslint/naming-convention -- matches window global
  return (window as Window & { __DPL_DEBUG_SESSION_ID?: string })
    .__DPL_DEBUG_SESSION_ID;
}

export interface ErrorToastMessageProps {
  responseCode: number;
}

export default function ErrorToastMessage({
  responseCode
}: ErrorToastMessageProps) {
  const { onClick = () => window.location.reload(), btnTxt = 'Reload' } =
    responseCode === 404
      ? {
          // let user go back; refreshing same page isnt helpful
          onClick: () => window.history.back(),
          btnTxt: 'Go back'
        }
      : {};

  const debugMessage = `(status: ${responseCode}; debug-id: ${getDebugSessionId()})`;

  return (
    <div className="ErrorToastMessage">
      <div className="flex font-16 mv1">
        <p>Something went wrong.</p>
        <button
          type="button"
          className="underline ml1 ml2-md stone-700 pointer"
          onClick={onClick}
        >
          {btnTxt}
        </button>
      </div>
      <p className="font-14 secondary">
        If the problem persists, please contact&nbsp;
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={`mailto:${HELP_EMAIL}?body=${window.encodeURIComponent(
            debugMessage
          )}`}
          className="underline"
        >
          {HELP_EMAIL}
        </a>
        &nbsp;and include the following: {debugMessage}
      </p>
    </div>
  );
}
